import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AdminAnalytics() {
  const [rows, setRows] = useState(null);
  const nav = useNavigate();

  useEffect(() => { api.get("/admin/analytics/questions").then((r) => setRows(r.data)); }, []);

  if (!rows) return <AdminLayout title="Analytics"><Loader2 className="w-6 h-6 animate-spin text-white/40" /></AdminLayout>;

  return (
    <AdminLayout title="Question difficulty">
      <p className="text-sm text-white/60 mb-6 max-w-2xl">Questions students get wrong most often — rewrite or add explanations to the ones at the top. Sorted by total wrong attempts.</p>

      <div className="bg-white/4 border border-white/10 rounded-lg overflow-hidden">
        <table className="w-full text-sm" data-testid="analytics-table">
          <thead className="bg-white/5 text-xs uppercase tracking-widest text-white/50 font-mono">
            <tr>
              <th className="text-left px-4 py-3">Question</th>
              <th className="text-center px-4 py-3 w-20">Cat</th>
              <th className="text-center px-4 py-3 w-20">Answer</th>
              <th className="text-center px-4 py-3 w-20">Correct</th>
              <th className="text-center px-4 py-3 w-20">Wrong</th>
              <th className="text-center px-4 py-3 w-24">Success</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.question_id} onClick={() => nav(`/admin/questions/${r.question_id}`)}
                className="border-t border-white/8 hover:bg-white/5 cursor-pointer" data-testid={`analytics-row-${r.question_id}`}>
                <td className="px-4 py-3 truncate max-w-md">{r.text_pt}</td>
                <td className="px-4 py-3 font-mono text-xs text-center">{r.category_code}</td>
                <td className="px-4 py-3 text-center"><span className="font-mono text-xs bg-white/8 rounded px-1.5 py-0.5">{r.correct_letter}</span></td>
                <td className="px-4 py-3 text-center font-mono text-emerald-400">{r.correct}</td>
                <td className="px-4 py-3 text-center font-mono text-red-400">{r.wrong}</td>
                <td className="px-4 py-3 text-center">
                  <div className="flex items-center gap-2 justify-center">
                    <div className="w-16 h-1.5 bg-white/10 rounded-full overflow-hidden"><div className={`h-full ${r.success_rate >= 75 ? "bg-emerald-500" : r.success_rate >= 50 ? "bg-[hsl(var(--accent))]" : "bg-red-500"}`} style={{ width: `${r.success_rate}%` }} /></div>
                    <span className="font-mono text-xs w-9 text-right">{r.success_rate}%</span>
                  </div>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-white/40">No data yet — need students to attempt some questions first.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
